/**
 * The SQL driver seam of the local data layer.
 *
 * Everything above this interface (migrations, repositories, sync metadata) is
 * driver-agnostic TypeScript. Two drivers implement it:
 *
 *  - `drivers/node.ts` — Node's built-in `node:sqlite`, used by tests and any
 *    desktop tooling. Synchronous underneath, async at the seam.
 *  - `drivers/bridge.ts` — the Android kiosk, where SQL crosses the existing
 *    `window.KortexAndroid` bridge to a native framework-SQLite store.
 *
 * Interactive long-lived transactions are deliberately NOT part of the seam:
 * holding a transaction open across async bridge round trips is how a till
 * ends up with a stuck write lock. Atomic units are expressed as a `batch` -
 * a list of statements the driver executes under one BEGIN IMMEDIATE … COMMIT,
 * rolling back the lot on any failure. See ADR-002.
 */
/** Thrown by the data layer for domain-level failures (not driver/SQL errors). */
export class LocalDataError extends Error {
    code;
    constructor(code, message) {
        super(message);
        this.name = 'LocalDataError';
        this.code = code;
    }
}
//# sourceMappingURL=types.js.map